import { createContext } from "react";

export const darkTheme = {
	palette: {
		primary: { main: "#00FBD9", contrastText: "#FF00FF" },
		secondary: { main: "#FF00FF", contrastText: "#00FBD9" },
		mode: 'dark',
		text: {
			primary: "#00FBD9",
			secondary: "#fff",
			contrastText: "#FF00FF",
			header: "#00FBD9",
			graphLabel: "#00FBD9",
			link: "#FF00FF",
			border: "#06dcbf",
			menuUnderline: "#06dcbf",
			menuItemSelected: "#fff",
			menuItemGlow: "#06dcbf",
			sidebarTextPrimary: "#00FBD9",
			sidebarTextSecondary: "#fff",
		},
		background: {
			default: "#2b2a2a",
			paper: "#2b2a2a", //"#101010",
			sidebar: "#2b2a2a",
			header: "#101010",
			// card: "#343333",
			card: "#2b2a2a",
			inputLabel: "#4b4b4b",
			category: "#4b4b4b",
		},
		divider: "#262626",
		boxborder: "#767676"
	},
	typography: {
		fontFamily: [
			'Plus Jakarta Sans',
			'-apple-system',
			'BlinkMacSystemFont',
			'"Segoe UI"',
			'Arial',
			'sans-serif',
			'Roboto',
			'"Helvetica Neue"',
			'"Apple Color Emoji"',
			'"Segoe UI Emoji"',
			'"Segoe UI Symbol"',
		].join(','),
	}
};

export const lightTheme = {
	palette: {
		primary: { main: "#2b2a2a", contrastText: "#FF00FF" },
		secondary: { main: "#FF00FF", contrastText: "#00FBD9" },
		mode: 'light',
		text: {
			primary: "#2b2a2a",//"#06dcbf",
			secondary: "#2b2a2a",
			header: "rgba(0, 0, 0, 0.87)",
			graphLabel: "#fff",
			link: "#90caf9",
			border: "#06dcbf",
			menuUnderline: "#06dcbf",
			menuItemSelected: "#fff",
			menuItemGlow: "#06dcbf",
			sidebarTextPrimary: "#00FBD9",
			sidebarTextSecondary: "#fff",
		},
		background: {
			default: "#fff",
			paper: "#fff",
			sidebar: "#2b2a2a",
			header: "#fff",
			card: "#fff",
			inputLabel: "#fff",
			category: "#eee",
			// default: "#eee",
			// paper: "#fff",
			// sidebar: "#eee",
			// header: "#eee",
			// card: "#fff",
			// inputLabel: "#fff"
		},
		divider: "#eee",
		boxborder: "#cccccc"
	},
	typography: {
		fontFamily: [
			'Plus Jakarta Sans',
			'-apple-system',
			'BlinkMacSystemFont',
			'"Segoe UI"',
			'Arial',
			'sans-serif',
			'Roboto',
			'"Helvetica Neue"',
			'"Apple Color Emoji"',
			'"Segoe UI Emoji"',
			'"Segoe UI Symbol"',
		].join(','),
	}
};

export const contentBoxStyle = {
	flexGrow: 1,
	color: "text.primary",
	padding: "0em 4em 0 4em",
	display: "flex",
	flexDirection: "column"
};

export const borderStyle = {
	borderColor: "text.border"
};

export const greyBorderStyle = {
	borderColor: "text.border"
};

export const defaultLogoUrls = {
	"light": "/dark-cymplify-logo-small.png",
	"dark": "/light-cymplify-logo-small.png"
};

export const sidebarLogoUrls = {
	"light": "/dark-cymplify-logo-sidebar.png",
	"dark": "/light-cymplify-logo-sidebar.png"
};

export const AccountRecoveryIconUrls = {
	"light": "/services/account-recovery.png",
	"dark": "/services/account-recovery.png",
};

export const ProtectionIconUrls = {
	"light": "/services/protection.png",
	"dark": "/services/protection.png",
};

export const ChipIconUrls = {
	"light": "/services/chip.png",
	"dark": "/services/chip.png",
};

export const ComplianceAuditIconUrls = {
	"light": "/services/compliance-audits.png",
	"dark": "/services/compliance-audits.png",
};

export const ComplianceIconUrls = {
	"light": "/services/compliance.png",
	"dark": "/services/compliance.png",
};
export const ConsultingIconUrls = {
	"light": "/services/consulting.png",
	"dark": "/services/consulting.png",
};
export const IncidentResponseIconUrls = {
	"light": "/services/incident-response.png",
	"dark": "/services/incident-response.png",
};

export const SupplyChainManagementIconUrls = {
	"light": "/services/supply-chain-management.png",
	"dark": "/services/supply-chain-management.png",
};

export const TwoFactorAuthIconUrls = {
	"light": "/services/two-factor-authentication.png",
	"dark": "/services/two-factor-authentication.png",
};

export const cardStyle = {
	backgroundColor: "background.card",
	margin: "0.75em",
	borderRadius: "0.75em",
	height: "90%"
};

export const ThemeModeContext = createContext(null);
